/** @format */
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const autoLoadingPathnames = ['/return', '/quote-summary'];

export const useAutoLoadIntercom = () => {
    const router = useRouter();

    const isEnabledByDefault = autoLoadingPathnames.some((path) =>
        router.pathname.startsWith(path)
    );

    const [autoEnabled, setAutoEnabled] = useState<boolean>(isEnabledByDefault);

    useEffect(() => {
        setAutoEnabled(isEnabledByDefault);
    }, [isEnabledByDefault, setAutoEnabled]);

    return autoEnabled;
};
